import { useState } from 'react';

interface StatusButtonsProps {
    statuses: Array<{
        id: string;
        label: string;
        color?: {
            text: string;
            bg: string;
        };
    }>;
    selectedStatuses: string[];
    onChange: (statuses: string[]) => void;
}

export default function StatusButtons({ statuses, selectedStatuses, onChange }: StatusButtonsProps) {
    const getStatusStyle = (status: string) => {
        switch (status.toLowerCase()) {
            case 'success':
                return 'bg-[#1C3829] text-[#4ADE80]';
            case 'warning':
                return 'bg-[#92400E] text-[#FBBF24]';
            case 'error':
            case 'failed':
                return 'bg-[#7F1D1D] text-[#F87171]';
            case 'info':
                return 'bg-[#1E3A8A] text-[#60A5FA]';
            case 'pending':
                return 'bg-[#374151] text-[#9CA3AF]';
            case 'sent':
                return 'bg-[#1C3829] text-[#4ADE80]';
            case 'delivered':
                return 'bg-[#065F46] text-[#34D399]';
            case 'bounced':
                return 'bg-[#7F1D1D] text-[#F87171]';
            default:
                return 'bg-[#374151] text-[#9CA3AF]';
        }
    };

    return (
        <div className="flex flex-wrap gap-2">
            {statuses.map((status) => (
                <button
                    key={status.id}
                    onClick={() => onChange(
                        selectedStatuses.includes(status.id) 
                            ? selectedStatuses.filter(id => id !== status.id)
                            : [...selectedStatuses, status.id]
                    )}
                    className={`px-4 py-1 rounded-full text-sm font-medium min-w-[100px] transition-colors ${
                        selectedStatuses.includes(status.id)
                            ? getStatusStyle(status.label)
                            : 'bg-[#2A2A2A] text-gray-400 hover:bg-[#3a3a3a33] hover:text-white'
                    }`}
                >
                    {status.label}
                </button>
            ))}
        </div>
    );
} 